export class SupportDataForm {
    userDetailsId: number;
    enquiryMessage: string;
    imageUrl: string;
    currentPageUrl: string;
  }
  
  